module.exports = __webpack_public_path__ + "static/b1-julie-1cba1888b4ca7e8a87c068ee61f39cec.jpg";